import { ConditionalPartial } from '../../utils';
import { CreateYearlyTestRecordRequestDto } from './create-yearly-test-record.request.dto';

/**
 * DTO for updating a yearly test record
 * All fields from CreateYearlyTestRecordRequestDto are optional
 */
export class UpdateYearlyTestRecordRequestDto extends ConditionalPartial(CreateYearlyTestRecordRequestDto) {}


